import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom';

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../../actions";

//Router
import {
    Route,
    Switch
} from "react-router-dom";

// Screens
import FundsScreen from './FundsScreen';
import TitlesScreen from './TitlesScreen';

// Utils
import AddIcon from '@material-ui/icons/Add';
import { MyTab, MyTabs } from "../../../utils/MyTabs";
import SearchBar from '../../../utils/SearchBar';
import UnoButton from '../../../utils/UnoButton';

// Styles
import PrintIcon from '@material-ui/icons/Print';
import { FundAPI } from "../../../../API/fund";
import { FundLocalQuotasAPI } from "../../../../API/fund_local_quotas";
import menuItems from "../../../dashboard/menuItems";
import SelectDateModal from "../../../modals/SelectDateModal";
import { administrationFundsScreenPaths, path } from "../../../utils/routesPaths";
import { checkUserIsRole, roles } from "../../../utils/user";
import { getDayMonthYearByPtDate, getLastDateAbleToQuotas, getShortMonthName } from "../../../utils/utils";
import { useIndexStyles } from "./styles";

//Import excel
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from "../../../../controllers/ExcelController";
import moment from "moment";

/**
 * Componente para:
 * - Exibição de abas de fundos e títulos para administrador;
 * - Lidar com redirecionamento de abas;
 */
export default function FundsAndTitlesScreen({
    setShowMonths,
    setShowYears,
    locationOnScreen,
    setLocationOnScreen
}) {

    const classes = useIndexStyles();

    const currentUser = useSelector(state => state.currentUser)

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const [search, setSearch] = useState("");

    const [tabValue, setTabValue] = useState(0);
    const IS_FUNDS_TAB = tabValue === 0;

    const [tabs,] = useState([
        {
            label: 'Fundos',
            path: path.administration.funds.all,
            disabled: false,
        },
        {
            label: 'Títulos',
            path: path.administration.funds.titles,
            disabled: false,
        }
    ]);

    const [flagDoReportBatchAprs, setFlagDoReportBatchAprs] = React.useState(0);

    function resetFlag() {

        setFlagDoReportBatchAprs(false);

    };

    const redirectTab = (newTabValue) => {
        tabs.forEach((tab, index) => {
            if (newTabValue === index) {
                return history.push(tab.path);
            }
        });
    };

    const handleChangeTabValue = (event, newValue) => {
        setTabValue(newValue);
        redirectTab(newValue);
    };

    function redirect() {
        const FUNDS_INDEX = 2;
        const PATH_OF_THE_FIRST_BACKOFFICE_SUBMENU = menuItems.backofficeMenu[FUNDS_INDEX].path;
        if (location.pathname === PATH_OF_THE_FIRST_BACKOFFICE_SUBMENU) {
            history.push(administrationFundsScreenPaths.home);
            const HOME_TAB = 0;
            setTabValue(HOME_TAB);
        };
    };

    const [openSelectDateModal, setOpenSelectDateModal] = useState();



    const doUpdateAllFundsInfosComdinheiro = async (date) => {
        if (date) {

            const month = date.month() + 1;
            const year = date.year()

            const response = await FundAPI.updateAllFundInfosComdinheiro(month, year);
        } else {
            setOpenSelectDateModal(false);
        }

    }

    const doExcelFundsAdmins = async () => {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha...',
        }));

        const { month, year } = getDayMonthYearByPtDate(getLastDateAbleToQuotas());
        const allFundsIdsAndNames = await FundAPI.getAllFundsMainAtts();
        if (allFundsIdsAndNames.success) {

            const localInfos = await FundLocalQuotasAPI.getLocalInfosByArrayFundsIds(allFundsIdsAndNames.body.rows.map(el => el.id), month, year);
            if (localInfos.success) {
                const infosMapById = {};
                localInfos.body.rows.forEach(element => {
                    infosMapById[element.fund_id] = JSON.parse(element.json_fund_infos);
                });

                allFundsIdsAndNames.body.rows.forEach(element => {
                    if (infosMapById[element.id]) {
                        element.administrator = infosMapById[element.id].administrator_anbima;
                        element.administratorCnpj = infosMapById[element.id]?.dados_cadastrais?.administrator_cnpj
                        element.manager = infosMapById[element.id].manager_anbima;
                        element.managerCnpj = infosMapById[element.id]?.dados_cadastrais?.manager_cnpj;
                    }
                });

                const formatted = allFundsIdsAndNames.body.rows;

                const fileName = "Funds_Admins_Gestores_" + getShortMonthName(month) + "_" + year;

                const wb = XLSX.utils.book_new();
                wb.Props = {
                    Title: fileName,
                    Author: "UNO",
                }

                const sheetName = "Fundos";
                wb.SheetNames.push(sheetName);

                const ws_data = [];

                ws_data.push([
                    'FUNDO',
                    'CNPJ',
                    'ENQUADRAMENTO',
                    'BENCHMARK',
                    'LIQUDEZ',
                    'CARÊNCIA',
                    'ADMINISTRADOR',
                    'ADMINISTRADOR CNPJ',
                    'GESTOR',
                    'GESTOR CNPJ',
                    'DISTRIBUIDOR',
                    'DISTRIBUIDOR CNPJ',
                    'INICIO FUNDO',
                    'FIM FUNDO',
                ])

                formatted.forEach(element => {
                    ws_data.push([
                        element.fund_name,
                        element.cnpj,
                        element.article,
                        element.benchmark,
                        element.liquidity,
                        element.lack_liquidity_date,
                        element.administrator,
                        element.administratorCnpj,
                        element.manager,
                        element.managerCnpj,
                        element.distributor_name,
                        element.distributor_cnpj,
                        moment.utc(element.init_fund).format('DD/MM/YYYY'),
                        element.end_fund ? moment.utc(element.end_fund).format('DD/MM/YYYY') : "",
                    ])
                });


                const ws = XLSX.utils.aoa_to_sheet(ws_data);

                wb.Sheets[sheetName] = ws;
                const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

                downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');

                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: false,
                }));
            }
        }






    }

    useEffect(() => {
        if ((location && !locationOnScreen)
            || (location && location.pathname != locationOnScreen.pathname)) {
            const isUserFirstTimeOnScreen = location.pathname === path.administration.funds.root;
            if (isUserFirstTimeOnScreen) {
                setShowMonths(false);
                setShowYears(false);
            };
            redirect();
            setLocationOnScreen(location);
        }
    }, [location]);

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>
                <div className={classes.tabs}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}
                        aria-label="disabled tabs example">

                        {tabs.map((tab, index) => {
                            return <MyTab label={tab.label} value={index} disabled={tab.disabled} />
                        })}

                    </MyTabs>

                    {/* <div className={classes.bottomTabs}></div> */}
                </div>

                {IS_FUNDS_TAB ?
                    // <form>
                    <SearchBar
                        style={{ width: "200px" }}
                        name='search_query'
                        size='large'
                        mask='text_cnpj'
                        variant='outlined'
                        label='Nome ou CNPJ'
                        setSearchQuery={setSearch}
                    />
                    // </form>
                    : null}

                <div className={classes.rightHeader}>
                    {
                        IS_FUNDS_TAB ?

                            //Botões dos fundos                            

                            <UnoButton
                                variant="contained"
                                type='primary'
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                    path: 'newFund',
                                }))}
                                startIcon={<AddIcon />}>
                                {"NOVO FUNDO"}
                            </UnoButton>

                            :
                            //Botões dos títulos   


                            <UnoButton
                                variant="contained"
                                type='primary'
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                    path: 'newTitle',
                                }))}
                                startIcon={<AddIcon />}>
                                {"NOVO TÍTULO"}
                            </UnoButton>


                    }

                    {
                        checkUserIsRole(currentUser, [roles.superadmin]) &&
                        <UnoButton
                            variant="contained"
                            type='warning'
                            onClick={() => setOpenSelectDateModal(true)}>
                            {"ATT INFOS COMD."}
                        </UnoButton>
                    }

                    {
                        checkUserIsRole(currentUser, [roles.superadmin]) &&
                        <UnoButton
                            variant="contained"
                            type='success'
                            startIcon={<PrintIcon />}
                            onClick={() => doExcelFundsAdmins()}>
                            {"FUNDOS/GESTORES"}
                        </UnoButton>
                    }


                </div>
            </div>


            <Switch className={classes.switch}>
                <Route path={path.administration.funds.all}>
                    <FundsScreen search={search} />
                </Route>
                <Route path={path.administration.funds.titles}>
                    <TitlesScreen />
                </Route>
            </Switch>

            <SelectDateModal open={openSelectDateModal}
                handleAction={doUpdateAllFundsInfosComdinheiro} />
        </div>
    );
}



